import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Button, Card } from 'react-bootstrap';
import { useAuth } from '../../context/AuthContext';
import { navigateToDashboard } from '../../utils/roleNavigation';

/**
 * Pagina mostrata quando un utente tenta di accedere a una risorsa
 * per cui non ha i permessi necessari (HTTP 403)
 */
const Unauthorized = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleGoHome = () => {
    if (user) {
      navigateToDashboard(navigate, user.role);
    } else {
      navigate('/login');
    }
  };

  return (
    <Container className="d-flex align-items-center justify-content-center" style={{ minHeight: '100vh' }}>
      <Row className="w-100">
        <Col md={8} lg={6} className="mx-auto">
          <Card className="shadow-lg border-0">
            <Card.Body className="text-center p-5">
              <div className="mb-4">
                <i className="bi bi-shield-exclamation text-warning" style={{ fontSize: '5rem' }}></i>
              </div>
              
              <h1 className="display-4 fw-bold text-danger mb-3">403</h1>
              <h2 className="mb-4">Accesso Non Autorizzato</h2>
              
              <p className="text-muted mb-4">
                Non hai i permessi necessari per accedere a questa pagina o eseguire questa operazione.
              </p>

              {user && (
                <div className="alert alert-info mb-4">
                  <i className="bi bi-info-circle me-2"></i>
                  Sei autenticato come: <strong>{user.username}</strong> ({user.role})
                </div>
              )}

              <p className="text-muted mb-4">
                Se ritieni che questo sia un errore, contatta l'amministratore del sistema.
              </p>

              <div className="d-flex gap-3 justify-content-center flex-wrap">
                <Button variant="outline-secondary" onClick={handleGoBack}>
                  <i className="bi bi-arrow-left me-2"></i>
                  Torna Indietro
                </Button>
                <Button variant="primary" onClick={handleGoHome}>
                  <i className="bi bi-house-door me-2"></i>
                  Vai alla Dashboard
                </Button>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Unauthorized;
